import { Button, CircularProgress, IconButton, Paper } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { FC } from "react";

import InfoMessageComponent from "../InfoMessageComponent/InfoMessageComponent";
import useStyles from "./styles";
import { getMessageTypeFromFromFile } from "./utils";

interface TDisplayFileComponentProps {
  selectedFile: File;
  isLoading: boolean;
  isRedirecting: boolean;
  errorMessageFromApi: string;
  onUnselectFile: () => void;
  onUpload: () => void;
  onClose: () => void;
}

const DisplayFileComponent: FC<TDisplayFileComponentProps> = ({
  selectedFile,
  isLoading,
  isRedirecting,
  errorMessageFromApi,
  onUnselectFile,
  onUpload,
  onClose
}) => {
  const classes = useStyles({});

  const infoMessageType = getMessageTypeFromFromFile(
    selectedFile,
    isRedirecting
  );

  const isLoadingOrRedirect = isLoading || isRedirecting;

  return (
    <div>
      <Paper className={classes.styedPaper}>
        <div />
        <div className={classes.paperContents}>
          <div>{selectedFile.name}</div>
          {isLoadingOrRedirect ? (
            <CircularProgress className={classes.spinnerContainer} size={24} />
          ) : (
            <IconButton
              className={classes.deleteIcon}
              id="DeleteUploadedFileId"
              onClick={onUnselectFile}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
      </Paper>
      <InfoMessageComponent
        messageType={infoMessageType}
        errorMessageFromApi={errorMessageFromApi}
        isLoading={isLoading}
      />
      {infoMessageType === "info" &&
        errorMessageFromApi === "" &&
        !isLoadingOrRedirect && (
          <div className={classes.footerButtonsContainer}>
            <Button variant="text" onClick={onClose} disabled={isLoading}>
              CANCEL
            </Button>
            <Button variant="contained" onClick={onUpload} disabled={isLoading}>
              UPLOAD
            </Button>
          </div>
        )}
    </div>
  );
};

export default DisplayFileComponent;
